













import { Component, Prop } from "vue-property-decorator";
import AbstractScene from "@/components/AbstractScene.vue";
import WallBackground from "@/components/WallBackground.vue";
import BasePowaComponent from "@/components/BasePowaComponent.vue";
import StarBackground from "@/components/StarBackground.vue";

@Component({
  components: { WallBackground, BasePowaComponent, StarBackground },
})
export default class PowaScene extends AbstractScene {
  fade = "fadein";
  endPowa(): void {
    setTimeout(() => (this.fade = "fadeout"), 500);
  }
  fadeEnd(e: AnimationEvent): void {
    if (e.animationName.indexOf("fadeout") === 0) {
      this.done();
    }
  }
}
